import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import StageHeader from '../../components/stageHeader';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './quoteList.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsService from '../../services/axios/tmsService';
import Pagination from '../../components/pagination';
import Pager from '../../components/pager';
import { Select } from 'element-ui';
import { Option } from 'element-ui';
import switchBillingToService from '../../shared/switchBillingToService';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';

import util from '../../shared/util';
Vue.use(Select);
Vue.use(Option);
@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        Pagination,
        Pager,
    },
})
export default class QuoteList extends Vue {
    truckloadForm: any = {};
    editProductModal: string = 'addNewPaymentMethod';
    foldBody: number = 0;
    invoicesArr: any = {};
    searchStatus: any = '';
    searchParams: any = {
        page_size: 10,
        page: 1,
        status: '',
        location: '',
        quote_number: '',
    };
    paging: any = {
        pageSize: 10,
        currentPage: 1,
        totalSize: 0,
        text: 'quotes',
    };
    statusArr: any = [
        { value: '0', label: 'All' },
        { value: '1', label: 'Accepted' },
        { value: '2', label: 'Expired' },
        { value: '3', label: 'Needs review' },
    ];
    bill_to_id: any = '';
    quoteList: any = [];
    selectQuoteId: any = '';
    locationArr: any = [];
    loading: Boolean = false;
    isGettingQuoteList = false;

    async mounted() {
        localStorage.setItem('gettingStartedId', '');
        util.showUserWalkthrough();
        this.bill_to_id = await this.getCustomerInfo();
        if (this.bill_to_id) {
            this.getQuoteList({ currentPage: '1' });
            this.getQuoteListForExpired();
        } else {
            /* util.showUserWalkNext('SchedulePickupQuotes', this);*/
        }
    }
    editProductAction(modalName: any) {
        this.editProductModal = modalName;
        this.$modal.show(modalName);
    }
    closeModal() {
        this.$modal.hide(this.editProductModal);
    }
    saveProduct() {
        // this.validate();
    }

    getQuoteListForExpired() {
        tmsServiceBackend
            .get(
                `/quote/getQuoteLines?billto_id=${
                    this.bill_to_id
                }&quote_from=LAST_MILE_SERVICE,TMS_MILE_SERVICE,TMS_QUOTE_SERVICE,UNIS_500_QUOTE_SERVICE,SHARE_TRUCK_LOAD&page_size=1&page=1&input_search_status_type=2`
            )
            .then(
                (res: any) => {
                    let quoteList = res.data.data;
                    if (quoteList && quoteList.length > 0) {
                        localStorage.setItem('gettingStartedId', quoteList[0].tms_quote_id);
                    } else localStorage.setItem('gettingStartedId', '');
                },
                (err: any) => {
                    console.log(err);
                }
            );
    }

    getQuoteList(page: any) {
        this.isGettingQuoteList = true;
        if (page.pageSize) {
            this.paging.pageSize = page.pageSize;
        }
        this.searchParams.page = page.currentPage;
        tmsServiceBackend
            .get(
                `/quote/getQuoteLines?billto_id=${
                    this.bill_to_id
                }&quote_from=LAST_MILE_SERVICE,TMS_MILE_SERVICE,TMS_QUOTE_SERVICE,UNIS_500_QUOTE_SERVICE,SHARE_TRUCK_LOAD&page_size=${
                    this.paging.pageSize
                }&page=${this.searchParams.page}&input_search_status_type=${
                    this.searchParams.status
                }&input_search_shipper_consignee_text=${
                    this.searchParams.location
                }&input_search_quote_id=${this.searchParams.quote_number}`
            )
            .then(
                (res: any) => {
                    this.quoteList = res.data.data;
                    this.quoteList.forEach((item: any) => {
                        item.showOption = false;
                        item.isSelect = false;
                        if (item.status_text.indexOf('Expires in') > -1) {
                            item.status_text = item.status_text + 'd';
                        }
                        item.total_pallet =
                            item.total_pallet > 1
                                ? item.total_pallet + ' pallets'
                                : item.total_pallet + ' pallet';
                    });
                    this.paging.pageSize = res.data.per_page;
                    this.paging.currentPage = res.current_page;
                    this.paging.totalSize = res.data.total;

                    this.isGettingQuoteList = false;
                },
                (err: any) => {
                    console.log(err);
                    this.isGettingQuoteList = false;
                }
            );
    }

    selectStatus() {
        this.getQuoteList(1);
    }

    getCustomerInfo() {
        return new Promise((resolve: any, reject: any) => {
            switchBillingToService.post().then(
                (res: any) => {
                    if (res.data.billing != undefined && res.data.billing.location_id) {
                        resolve(res.data.billing.location_id);
                    } else {
                        resolve('');
                    }
                },
                (err: any) => {
                    console.log(err);
                    resolve('');
                }
            );
        });
    }

    getLocation(key: any) {
        this.loading = true;
        tmsServiceBackend.get(`/cpv2/quote/getWiseFacilitiesAndTmsAddress?search_text=${key}`).then(
            (res: any) => {
                this.locationArr = res.data.data;
                this.loading = false;
            },
            (err: any) => {
                this.loading = false;
                console.log(err);
            }
        );
    }

    showOptions(index: any) {
        this.quoteList[index].showOption = !this.quoteList[index].showOption;
        this.$forceUpdate();
    }

    goQuotePage() {
        this.$router.replace({
            name: 'Quote',
        });
    }

    scheduleAPickup(id: any) {
        this.$router.replace({
            name: 'estimatedQuote',
            query: {
                quoteId: this.selectQuoteId,
            },
        });
    }

    chooseItem(item: any) {
        if (item.isSelect) {
            item.isSelect = false;
            this.quoteList.forEach((item: any) => {
                item.isSelect = false;
            });
            this.selectQuoteId = '';
            this.$forceUpdate();
        } else {
            this.quoteList.forEach((item: any) => {
                item.isSelect = false;
            });
            this.$forceUpdate();
            item.isSelect = true;
            this.selectQuoteId = item.tms_quote_id;
        }
    }

    editQuote(item: any) {
        localStorage.setItem('ShipmentViewFrom', '4');
        this.$router.push({
            name: 'ShipmentView',
            params: {
                orderId: item.fk_tms_order_id,
                from: '4',
            },
        });
        /* let quoteType: any = '';
         if (type == 'LAST_MILE_SERVICE') {
             quoteType = 'lastmile';
         } else {
             quoteType = 'truckload';
         }
         this.$router.replace({
             name: 'Quote',
             params: {
                 isEdit: 'true',
                 quoteType: quoteType,
                 quoteNumber: id
             }
         });*/
    }

    tagFoldBody(foldNmae: any) {
        if (this.foldBody == foldNmae) this.foldBody = 0;
        else this.foldBody = foldNmae;
    }

    onItemSelect(id: any) {
        this.$router.push({
            name: 'estimatedQuote',
            query: {
                quoteId: id,
            },
        });
    }

    fillterStatusName(foldNmae: string) {
        if (foldNmae.indexOf('Expires') > -1) {
            return 'Expired';
        } else return foldNmae;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/quoteList/index.ts